import { Keys, Scene } from "excalibur";
import { Player } from "../../player";
import { OpenHive } from "../../actors/openHive";
import { goToScene } from "../../main";
import {
  addBroodBox,
  addHoneyBox,
  getHiveSprite,
  removeBroodBox,
  removeHoneyBox,
  sendAlert,
  startStingTimer,
} from "../../utils";
import { inventoryState, playerState } from "../../state/stateManager";
import { Resources } from "../../Resources";

export default class BoxesMenu extends Scene {
  constructor() {
    super();
    const player = new Player(350, 170, () => {
      this.setPlayerAnim(false);
    });
    this.player = player;

    this.player.z = 3;
    this.player.cutScene = true;

    this.activeItem = 0;
    this.selected = null;
    this.menuItems = 2;
    this.playerAnim = false;
  }
  setPlayerAnim(set) {
    console.log("setting playerAnim: ", set);
    this.playerAnim = set;
  }

  onActivate(data) {
    console.log("data from activation: ", data);
    this.hiveStats = data.data;
    const hive = new OpenHive(335, 170, this.hiveStats);
    this.hive = hive;
    this.camera.zoom = 4;
    this.add(this.player);

    this.add(this.hive);
    this.menuContainer = document.getElementById("hive-menu-container");
    this.menuContainer.style.display = "flex";
    this.boxesMenu = document.getElementById("boxes-menu");
    console.log("boxesMenu: ", this.boxesMenu);
    this.boxesMenu.style.display = "block";
    this.boxesMenu.innerHTML = `<h1>Hive: ${this.hiveStats.id}</h1>
    
    ${showBoxesMenu(0)}
    `;
    if (this.hiveStats.alive) {
      this.stingTimer = startStingTimer(
        this.hiveStats,
        "menu",
        this.camera,
        () => {
          //check for stingTolerance, if over, kick back to proper scene
          let content = playerState.getContent();
          if (content.stings.count >= content.stingTolerance) {
            sendAlert("Over Sting Tolerance. Not Enough Zeal.");
            this.stopTimer();
            if (this.hiveStats.position.yard == "home") {
              goToScene("home");
            } else {
              goToScene("back40", {
                x: this.hiveStats.position.x,
                y: this.hiveStats.position.y,
              });
            }
          }
        }
      );
      this.stingTimer.start();
    }
  }
  onPreUpdate() {
    if (!this.playerAnim) {
      this.player.doAnim("leftIdleBobble");
    } else {
      this.player.doAnim("addBox");
    }
  }
  onPostUpdate() {
    console.log("this.playerAnim", this.playerAnim);

    if (this.engine.input.keyboard.wasPressed(Keys.Up)) {
      console.log("pressed up");
      Resources.Click.play();
      if (this.activeItem > 0) {
        this.activeItem = this.activeItem - 1;
      } else {
        this.activeItem = this.menuItems - 1;
      }

      if (this.selected == null) {
        this.boxesMenu.innerHTML = `<h1>Hive: ${
          this.hiveStats.id
        }</h1>${showBoxesMenu(this.activeItem)}`;
      } else {
        if (this.selected == 1) {
          this.boxesMenu.innerHTML = `<h1>Hive: ${
            this.hiveStats.id
          }</h1>${showRemoveMenu(this.activeItem)}`;
        } else {
          this.boxesMenu.innerHTML = `<h1>Hive: ${
            this.hiveStats.id
          }</h1>${showAddMenu(this.activeItem)}`;
        }
      }

      return;
    }
    if (this.engine.input.keyboard.wasPressed(Keys.Down)) {
      Resources.Click.play();
      console.log("pressed down");
      if (this.activeItem < this.menuItems - 1) {
        this.activeItem++;
      } else {
        this.activeItem = 0;
      }

      if (this.selected == null) {
        this.boxesMenu.innerHTML = `<h1>Hive: ${
          this.hiveStats.id
        }</h1>${showBoxesMenu(this.activeItem)}`;
      } else {
        if (this.selected == 1) {
          this.boxesMenu.innerHTML = `<h1>Hive: ${
            this.hiveStats.id
          }</h1>${showRemoveMenu(this.activeItem)}`;
        } else {
          this.boxesMenu.innerHTML = `<h1>Hive: ${
            this.hiveStats.id
          }</h1>${showAddMenu(this.activeItem)}`;
        }
      }
      return;
    }
    if (this.engine.input.keyboard.wasPressed(Keys.X)) {
      console.log("pressed x should go back");
      //go back
      this.boxesMenu.style.display = "none";
      this.menuContainer.style.display = "none";
      this.selected = null;
      goToScene("hiveMenu", this.hiveStats);
    }
    if (this.engine.input.keyboard.wasPressed(Keys.Enter)) {
      if (this.selected == null) {
        if (this.activeItem == 0) {
          //selected add box
          this.activeItem = 0;
          this.selected = 0;
          this.boxesMenu.innerHTML = `<h1>Hive: ${
            this.hiveStats.id
          }</h1>${showAddMenu(this.activeItem)}`;
        } else {
          //selected remove box
          this.activeItem = 0;
          this.selected = 1;
          this.boxesMenu.innerHTML = `<h1>Hive: ${
            this.hiveStats.id
          }</h1>${showRemoveMenu(this.activeItem)}`;
        }
      } else {
        let inventory = inventoryState.getInventory();
        if (this.selected == 0) {
          //add
          if (this.activeItem == 0) {
            //add brood
            if (inventory.boxes > 0) {
              if (
                this.hiveStats.overallFrames.queenAccess <= 10 &&
                this.hiveStats.overallFrames.count <= 50
              ) {
                this.setPlayerAnim(true);

                let newHive = addBroodBox(this.hiveStats);
                console.log("setting newhive: ", newHive, this.hive);
                this.hive.hiveStats = newHive;
                this.hive.activeSprite = getHiveSprite(newHive);
                this.hiveStats = newHive;
                inventory.boxes = inventory.boxes - 1;
                Resources.WoodSound.play();
                console.log("added brood: ", newHive);
              } else {
                Resources.Error.play();
                sendAlert("Max 2 Brood Boxes, 6 Overall Boxes", () => {});
              }
            } else {
              Resources.Error.play();
              sendAlert("Not Enough Boxes", () => {});
            }
          } else {
            //add honey
            if (inventory.boxes > 1) {
              if (this.hiveStats.overallFrames.count <= 50) {
                this.setPlayerAnim(true);

                let newHive = addHoneyBox(this.hiveStats);
                console.log("setting newhive: ", newHive, this.hive);
                this.hive.hiveStats = newHive;
                this.hive.activeSprite = getHiveSprite(newHive);
                this.hiveStats = newHive;
                inventory.boxes = inventory.boxes - 1;
                console.log("added honey: ", newHive);
                Resources.WoodSound.play();
              } else {
                Resources.Error.play();
                sendAlert("Max 6 Boxes", () => {});
              }
            } else {
              Resources.Error.play();
              sendAlert("Not Enough Boxes", () => {});
            }
          }
        } else {
          //remove
          if (this.activeItem == 0) {
            //remove brood
            console.log("should remove brood if");
            if (
              this.hiveStats.overallFrames.queenAccess -
                (this.hiveStats.broodFrames.count +
                  this.hiveStats.foodFrames.count) >=
                10 &&
              this.hiveStats.overallFrames.queenAccess == 20
            ) {
              //remove brood
              console.log(
                "removing brood: overallFrames: ",
                this.hiveStats.overallFrames
              );
              const ret = removeBroodBox(this.hiveStats);
              this.hive.activeSprite = getHiveSprite(ret);
              this.hiveStats = ret;
              inventory.boxes++;
            } else {
              Resources.Error.play();
              sendAlert("Box Not Empty");
            }
          } else {
            //remove honey
            console.log("removeHoney ", this.hiveStats);
            let availableHoney =
              this.hiveStats.overallFrames.count -
              this.hiveStats.overallFrames.queenAccess;
            console.log(
              "removeHoney: overallFrames",
              this.hiveStats.overallFrames.count,
              " queenAccess",
              this.hiveStats.overallFrames.queenAccess
            );
            if (availableHoney - this.hiveStats.honeyFrames.count >= 10) {
              //remove honey

              const ret = removeHoneyBox(this.hiveStats);
              this.hiveStats = ret;
              this.hive.activeSprite = getHiveSprite(ret);
              inventory.boxes++;
            } else {
              Resources.Error.play();
              sendAlert("Box Not Empty");
            }
          }
        }
      }
    }
  }
  onDeactivate() {
    this.stingTimer && this.stingTimer.stop();
    this.selected = null;
    this.activeItem = 0;
    this.hive.kill();
  }
}
function showAddMenu(selected) {
  console.log("pressed enter, showing add boxes");
  switch (selected) {
    case 0:
      return `<h3>Add Box</h3><ul>
        <li id="list0"><span id="selector">></span>Add Brood Box</li>
        <li id="list1">Add Honey Box</li>
      
      </ul>`;
      break;
    case 1:
      return `<h3>Add Box</h3><ul>
        <li id="list0">Add Brood Box</li>
        <li id="list1"><span id="selector">></span>Add Honey Box</li>
      
      </ul>`;
      break;
    default:
      break;
  }
}
function showRemoveMenu(selected) {
  console.log("pressed enter, showing add boxes");
  switch (selected) {
    case 0:
      return `<h3>Remove Box</h3><ul>
          <li id="list0"><span id="selector">></span>Remove Brood Box</li>
          <li id="list1">Remove Honey Box</li>
        
        </ul>`;
      break;
    case 1:
      return `<h3>Remove Box</h3><ul>
          <li id="list0">Remove Brood Box</li>
          <li id="list1"><span id="selector">></span>Remove Honey Box</li>
        
        </ul>`;
      break;
    default:
      break;
  }
}
function showBoxesMenu(selected) {
  console.log("pressed enter, showing boxes");
  switch (selected) {
    case 0:
      return `<h3>Manage Boxes</h3><ul>
      <li id="list0"><span id="selector">></span>Add Box</li>
      <li id="list1">Remove Box</li>
    
    </ul>`;
      break;
    case 1:
      return `<h3>Manage Boxes</h3><ul>
      <li id="list0">Add Box</li>
      <li id="list1"><span id="selector">></span>Remove Box</li>
    
    </ul>`;
      break;
    default:
      break;
  }
}
